<div nz-row style="padding-left: 480px" *ngIf="!isLogedIn">
  <div class="limiter">
    <div class="container-login100" style="background-color: white;">
      <div class="wrap-login100">
        <h4 style="text-align: center; margin-bottom: 2px;">Welcome</h4>
        <h4 style="text-align: center; margin-bottom: 2px;"> To</h4>
        <h1 style="text-align: center; color: #208aeb; font-weight: bold;">
          Project Management System
        </h1>

        <form nz-form class="login-form">
          <nz-form-item>
            <nz-form-control nzRequired nzErrorTip="Please Enter Valid Email">
              <nz-input-group nzPrefixIcon="user">
                <input type="email" name="email_id"
                  pattern="^[_a-zA-Z0-9]+(\.[_a-zA-Z0-9]+)*@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*(\.[a-zA-Z]{2,4})$"
                  [(ngModel)]="EMAIL_ID" nz-input placeholder="Email" required />
              </nz-input-group>
            </nz-form-control>
          </nz-form-item>

          <nz-form-item>
            <nz-form-control nzRequired nzErrorTip="Input is required">
              <nz-input-group nzPrefixIcon="lock" [nzSuffix]="suffixTemplate">
                <input [type]="passwordVisible ? 'text' : 'password'" name="password" [(ngModel)]="PASSWORD" nz-input
                  placeholder="Password" required />
              </nz-input-group>
              <ng-template #suffixTemplate>
                <i nz-icon [nzType]="passwordVisible ? 'eye' : 'eye-invisible'"
                  (click)="passwordVisible = !passwordVisible"></i>
              </ng-template>
            </nz-form-control>
          </nz-form-item>

          <nz-form-item>
            <nz-form-control>
              <!-- <label nz-checkbox>
                <span>Remember me</span>
              </label> -->

              <!-- <a class="login-form-forgot" class="login-form-forgot">Forgot password</a> -->
              <div class="container-login100-form-btn">
                <div class="wrap-login100-form-btn">
                  <div class="login100-form-bgbtn"></div>
                  <button nz-button class="login100-form-btn" (click)="login()" [nzLoading]="isloginSpinning"
                    [nzType]="'primary'">Log in</button>
                </div>
              </div>
            </nz-form-control>
          </nz-form-item>
        </form>
      </div>
    </div>
  </div>
</div>